import { Component, Input } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { IFormDropDownItem } from "src/app/common-components/form-controls/form-dropdown/dropdown.component";
import { NoteDisplayLevelMobile } from "src/app/web-api/web-api";
import { NoteDisplayLevel } from "src/app/web-api/web-api";

export class WawiApiNoteFacilityCreateFormGroup extends FormGroup {
  public static get Note_MaxLength() {
    return 1000;
  }

  public constructor(fb: FormBuilder) {
    super({
      facilityNoInternal: fb.control("", Validators.required),
      displayLevelMobile: fb.control(NoteDisplayLevelMobile.Display),
      note: fb.control(
        "",
        Validators.compose([
          Validators.required,
          Validators.maxLength(
            WawiApiNoteFacilityCreateFormGroup.Note_MaxLength
          ),
        ])
      ),
      displayLevel: fb.control("", Validators.required),
    });
  }

  public get facilityNoInternal(): FormControl {
    return this.controls.facilityNoInternal as FormControl;
  }
  public get note(): FormControl {
    return this.controls.note as FormControl;
  }

  public get displayLevel(): FormControl{
    return this.controls.displayLevel as FormControl;
  }
}

@Component({
    selector: "app-wawi-note-facility-create-form",
    templateUrl: "./note-facility-create-form.component.html",
    styleUrls: ["./note-facility-create-form.component.scss"],
    standalone: false
})
export class WawiApiNoteFacilityCreateFormComponent {
  public NoteDisplayLevelMobileType = NoteDisplayLevelMobile;
  public NoteDisplaylevelType = NoteDisplayLevel;

  displayLevel: Array<IFormDropDownItem> =[  
    {
      label: $localize`:@@NoteDisplayLevel_Standard:Standard`,
      value: this.NoteDisplaylevelType.Standard,
    },
    {
      label: $localize`:@@NoteDisplayLevel_Hervorgehoben:Hervorgehoben`,
      value: this.NoteDisplaylevelType.Hervorgehoben,
    },
    {
      label: $localize`:@@NoteDisplayLevel_AktivAnzeigen:Aktiv anzeigen`,
      value: this.NoteDisplaylevelType.AktivAnzeigen,
    },
  ];

  @Input() form: WawiApiNoteFacilityCreateFormGroup;
}
